import React from "react";
import { ListGroup, Badge } from "react-bootstrap";
import { FaHeadset, FaPlus, FaCalendarAlt, FaCoins, FaFileMedicalAlt, FaFileAlt, FaFileMedical, FaHome } from "react-icons/fa";
import { hasPerm, getCurrentUser } from '../../common/utils';
import { getConfig } from "../../common/config";

const MenuPrestador = ({ pathname, faturamentosPendentes }) => {
  const dados_usuario = getCurrentUser();

  const configuracoes_programa = localStorage.getItem(`programa_configuracoes_${dados_usuario['ambiente_programa_id']}`);

  return (
    <>

        {dados_usuario["prestador_categoria"] == "medicos" && (
            <ListGroup variant="flush">
            <ListGroup.Item
                action
                href="/"
                className="itemMenu"
                active={pathname === "/"}
            >
                <FaHome /> Home
            </ListGroup.Item>
            </ListGroup>
        )}

      <div className="list-divider">
        <p>Atendimento ao Paciente</p>
      </div>

        {hasPerm("view_agendamentos") && dados_usuario['prestador_categoria'] !== 'medicos' && (
            <>
            {(getConfig(configuracoes_programa, "libera_agenda_prestador", false) === true || dados_usuario['ambiente_programa_id'] === 35 || dados_usuario['ambiente_programa_id'] === 11) ? (
                <ListGroup variant="flush">
                    <ListGroup.Item action href="/agendas" className="itemMenu" active={pathname === "/agendas" || pathname === "/agendas/" || (pathname === "/" && noDashboard)} >
                        <FaCalendarAlt /> Agenda
                    </ListGroup.Item>
                </ListGroup>
            ): (
                <ListGroup variant="flush">
                    <ListGroup.Item action href="/agendamentos" className="itemMenu" active={pathname.indexOf('/agendamentos') !== -1}>
                        <FaCalendarAlt /> Agendamentos
                    </ListGroup.Item>
                </ListGroup>
            )}
            </>
        )}

        {hasPerm("view_atendimentos") && (
            <ListGroup variant="flush">
                <ListGroup.Item action href="/atendimentos" className="itemMenu" active={pathname.indexOf("/atendimentos") !== -1} >
                    <FaHeadset /> Pacientes
                </ListGroup.Item>
            </ListGroup>
        )}

        {hasPerm("add_atendimentos") && hasPerm("view_atendimentos") && (
            <ListGroup variant="flush">
                <ListGroup.Item action href="/atendimentos/add" className="itemMenu">
                    <FaPlus /> Novo Paciente
                </ListGroup.Item>
            </ListGroup>
        )}
        
        {hasPerm('view_exames') && dados_usuario?.prestador_categoria === 'medicos' && (
        <ListGroup variant="flush">   
            <ListGroup.Item action href="/exames" className="itemMenu" active={pathname.indexOf('/exames') !== -1}>
                <FaFileMedical /> {getConfig(configuracoes_programa, "menu_medico.label_exames", 'Exames e Laudos')}
            </ListGroup.Item>    
        </ListGroup>
        )}

        {hasPerm('view_farmacovigilancia') && getConfig(configuracoes_programa, "farmacovigilancia.reporte_prestador", false) === true && (
            <ListGroup variant="flush">   
                <ListGroup.Item 
                    action 
                    href="/reportes-farmaco"
                    className="itemMenu" 
                    active={pathname.indexOf("/reportes-farmaco") !== -1}
                >
                    <FaFileMedicalAlt /> Reportar Evento Adverso
                </ListGroup.Item>      
            </ListGroup>
        )}  

        {dados_usuario?.prestador_categoria === 'medicos' && (
            <>
                <div className="list-divider">
                    <p>Termos</p>
                </div>
                <ListGroup variant="flush">
                    <ListGroup.Item action href="/termos-medicos" className="itemMenu" active={pathname.indexOf('/termos-medicos') !== -1}>
                        <FaFileAlt /> {getConfig(configuracoes_programa, "menu_medico.label_termos", 'Termos de Uso')}
                    </ListGroup.Item>
                </ListGroup>
            </>
        )}

        {hasPerm("view_faturamentos") && (
            <>
                <div className="list-divider">
                    <p>Gestão Financeira</p>
                </div>
                <ListGroup variant="flush">
                    <ListGroup.Item action href="/faturamentos" className="itemMenu" active={pathname.indexOf("/faturamentos") !== -1} >
                        <FaCoins /> Faturamentos
                        {faturamentosPendentes > 0 && (
                            <Badge pill bg="danger" className="ms-2">
                            {faturamentosPendentes}
                            </Badge>
                        )}
                    </ListGroup.Item>
                </ListGroup>
            </>
        )}
        
    </>
  );
};

export default MenuPrestador;
